<template>
  <section class="achievements container--Medium defaultSectionPaddings">
    <aside class="achievements__Aside stickyMenu">
      <div v-if="anchorsList.length" class="achievements__Anchors stickyMenuLinks">
        <button v-for="button in anchorsList" @click="scrollToSection(button.id)" :class="{'isActive': button.id === activeSectionId}">{{ button.title }}</button>
      </div>
    </aside>

    <div class="achievements__ListingWrapper">
      <div v-for="item in data" class="achievements__ListingGroup" :id="item.anchor_id || null">
        <template v-if="item.honors">
          <div v-for="honor in item.honors" class="achievements__ListingItem">
            <h2 v-text="honor.title" />
            <div class="achievements__ListingImageWrapper">
              <Flare v-if="honor?.gallery?.length" :srcset="honor.gallery[0]" width="400" :alt="honor.gallery[0].alt" />
            </div>
    
            <div v-if="honor.rich_text" class="achievements__ListingContent" v-html="honor.rich_text" />
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<script setup>
  const props = defineProps({
    data: {},
  });

  const { elements } = useIntersectionObserver((entry) => {
    if (entry.isIntersecting) {
      activeSectionId.value = entry.target.id;
    }
  }, { threshold: 0, rootMargin: '-100px 0px -100px 0px' });

  const activeSectionId = ref(null);
  const anchorsList = computed(() => props.data.map(item => ({ title: item.anchor_title, id: item.anchor_id })));

  function scrollToSection(id) {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  }

  onMounted(() => {
    elements.value = [...document.querySelectorAll('.achievements__ListingGroup')];
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_achievements.scss');
</style>